<script>
  import * as THREE from "three";
  import { onMount, getContext, setContext } from "svelte";
  import { audioEl, audioCtx } from "../stores/global.js";
  import Starfield from "./Universe.Starfield.svelte";

  export let group;
  export let starfieldGroup = new THREE.Group();

  let analyser, bufferLength, dataArray, source;
  let xR = 0;

  const { CAMERA, DEPTH, NEAR } = getContext("Universe");

  const impressions = {
    Arts: 0.0324,
    Business: 0.006,
    Comedy: 0.1012,
    Education: 0.0667,
    Fiction: 0.0189,
    Government: 0.0011,
    Health: 0.0707,
    History: 0.0182,
    "Kids & Family": 0.002,
    "Games and Hobbies": 0.0119,
    Music: 0.0147,
    News: 0.172,
    Politics: 0.0317,
    "Religion & Spirituality": 0.0075,
    Science: 0.0272,
    "Society & Culture": 0.1419,
    Sports: 0.1174,
    Technology: 0.0023,
    "True Crime": 0.0488,
    "TV & Film": 0.083,
  };

  const starfields = [{ count: 10000 }];

  const calcAudioData = () => {
    if (analyser && analyser.getFloatTimeDomainData)
      analyser.getFloatTimeDomainData(dataArray);
    requestAnimationFrame(calcAudioData);
  };

  const tick = () => {
    xR += 0.001;
    const x = Math.sin(xR) * 0.5;
    starfieldGroup.rotation.set(0, 0.75, 0.5);
    requestAnimationFrame(tick);
  };

  onMount(() => {
    CAMERA.add(starfieldGroup);
    starfieldGroup.position.set(0, 0, -500);
    tick();
    calcAudioData();
  });

  $: if ($audioCtx) {
    analyser = $audioCtx.createAnalyser();
    analyser.fftSize = 64;
    bufferLength = analyser.frequencyBinCount;
    dataArray = new Float32Array(bufferLength);
  }

  // $: if (source && $audioEl) {
  //   source.disconnect(analyser);
  //   source.disconnect($audioCtx.destination);
  // }
  $: if ($audioEl && $audioEl.getAttribute("src")) {
    // if (source) {
    //   source.disconnect(analyser);
    //   source.disconnect($audioCtx.destination);
    // }
    if (!source) {
      source = $audioCtx.createMediaElementSource($audioEl);
      source.connect(analyser);
      source.connect($audioCtx.destination);
    }
  }
</script>

{#each starfields as starfield}
  <Starfield
    audioData="{dataArray}"
    starfieldGroup="{starfieldGroup}"
    {...starfield}
  />
{/each}
